export default __webpack_public_path__ + "static/media/zayed-project-5.635ac2f2.jpg";